import { Status } from "./Status";

export class RecallStatusSmartEnum {
    static Draft = new Status("Draft", 1, "pill--yellow", "Draft");
    static Submitted = new Status("Submitted", 2, "pill--blue", "Submitted");
    static Processing = new Status("Processing", 3, "pill--blue", "Processing");
    static ToPick = new Status("To pick", 4, "pill--orange", "ToPick");
    static ToPack = new Status("To pack", 5, "pill--blue", "ToPack");
    static Cancelled = new Status("Cancelled", 6, "pill--red", "Cancelled");
    static Failed = new Status("Failed", 7, "pill--red", "Failed");
    static Completed = new Status("Completed", 8, "pill--green", "Completed");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "RecallStatusSmartEnum";
    }
}
